import "./choose_etape.css";

export const ETAPES = ["55SAGI1", "55GBS1", "55QIF1", "55BD1"];

function ChooseEtape({ selectedEtape, setSelectedEtape }) {
  return (
    <div className="ChooseEtape">
      <label htmlFor="etape-select">Choisir une étape :</label>
      <select
        id="etape-select"
        value={selectedEtape}
        onChange={(event) => setSelectedEtape(event.target.value)}
      >
        <option value="">--Sélectionner--</option>
        {ETAPES.map((etape) => (
          <option key={etape} value={etape}>
            {etape}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ChooseEtape;
